import { render, staticRenderFns } from "./SidebarEmpty.vue?vue&type=template&id=147bd7a6&"
import script from "./SidebarEmpty.vue?vue&type=script&lang=js&"
export * from "./SidebarEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports